import * as R from 'ramda'
import * as Urql from 'urql'
import * as ReactRouter from 'react-router-dom'
import * as React from 'react'
import gql from 'graphql-tag'

import * as Common from '@rushplay/common'
import { useI18n } from '@rushplay/i18n'

import { Button } from './button'
import { getSafeUpdateQuery } from './use-safe-update-query'
import { useGameInfoUrlQuery } from './use-game-info-url-query'

const getGame = gql`
  query Game($id: ID!) {
    game(id: $id) {
      id
      key
      loginRequired
      liveCasinoGame
    }
  }
`

export function GameInfoModeSelector() {
  const i18n = useI18n()
  const { gameId } = ReactRouter.useParams()
  const [response] = Urql.useQuery({
    query: getGame,
    variables: { id: gameId },
  })
  const history = ReactRouter.useHistory()
  const location = ReactRouter.useLocation()
  const gameInfoQuery = useGameInfoUrlQuery()
  const liveCasinoGame = R.pathOr(false, ['liveCasinoGame'], response.data)
  const game = R.pathOr({}, ['game'], response.data)

  const isLiveCasinoGame =
    R.includes('live-casino', game.key || '') ||
    R.equals('live-casino', gameInfoQuery.referrer) ||
    liveCasinoGame

  function handleLogin() {
    history.push(`?${getSafeUpdateQuery(location, { login: 'me' })}`)
  }

  if (isLiveCasinoGame) {
    return (
      <Button onClick={handleLogin}>
        <Common.Box textShadow="1px 1px 3px rgba(0, 0, 0, 0.5)">
          <Common.Text
            fontWeight="bold"
            fontSize={1}
            textDecoration="underline"
          >
            {i18n.translate('game-info.live-casino-unavailable')}
          </Common.Text>
        </Common.Box>
      </Button>
    )
  }

  return (
    <ReactRouter.Link to="/login">
      <Common.Box textShadow="1px 1px 3px rgba(0, 0, 0, 0.5)">
        <Common.Text fontWeight="bold" fontSize={1} textDecoration="underline">
          {i18n.translate('game-info.login-required')}
        </Common.Text>
      </Common.Box>
    </ReactRouter.Link>
  )
}
